import script from "./createVendor.vue?vue&type=script&setup=true&lang=js"
export * from "./createVendor.vue?vue&type=script&setup=true&lang=js"

import "./createVendor.vue?vue&type=style&index=0&id=9a772f06&lang=css"

const __exports__ = script;

export default __exports__